import { html, Page, View } from 'rune-ts';
import { LayoutView } from '../../../components/cells/Layout/LayoutView';
import { footer_links } from '../../../components/cells/Footer/constant';
import { type BaseLayoutOptions } from '../../../../features/Core/service';
import { MY_PAGE_TABS_MAP, type MyPageTabsOptionMap } from '../constant';
import klass from './Membership.module.scss';
import { MyPageBody } from '../views/MyPageBody/MyPageBody';
import { MyMembershipList } from '../../../../../../modules/MShop/App/Mypage/MembershipList/component/MyMembershipList';
import { NumericString } from '../../../../features/Membership/type';
import { updateUrlParams } from '../../../../shared/util';
import { MyPageTabsHookError, RenderOnRefreshHookError } from '../views/MyPageTabs/MyPageTabsError';
import { ConfigSentryF } from '../../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';
import { MembershipPayMethod } from '../../../../../../modules/MShop/App/Mypage/MembershipPayMethod/component/MembershipPayMethod';
import { SupportTab } from './views/SupportTab';
import { CommissionTab } from './views/CommissionTab';

export interface MyMembershipPageData {
  layout_options: BaseLayoutOptions;
  selected_tab: keyof typeof MY_PAGE_TABS_MAP;
  url: string;
  membership_token: string;
  project_domain_name_map: Record<NumericString, string>;
}

export class MyMembershipBodyView extends View<MyMembershipPageData> {
  my_page_tabs_option_map: Readonly<MyPageTabsOptionMap>;

  constructor(props: MyMembershipPageData) {
    super(props);

    this.my_page_tabs_option_map = {
      membership: {
        selected: MY_PAGE_TABS_MAP.membership === this.data.selected_tab,
        value: ET('mps2::membership::main::title'),
        view: new MyMembershipList(this.data),
        postRenderOnSelectedHook() {
          history.replaceState(
            history.state,
            '',
            updateUrlParams(location.href, { tab: MY_PAGE_TABS_MAP.membership }),
          );
        },
        catchOnErrorHook(myPageTabHookError?: MyPageTabsHookError) {
          if (RenderOnRefreshHookError.is(myPageTabHookError)) {
            ConfigSentryF.capture(myPageTabHookError);
          }
        },
      },
      commission: {
        selected: MY_PAGE_TABS_MAP.commission === this.data.selected_tab,
        value: ET('mps2::membership::commission::title'),
        view: new CommissionTab(this.data),
        postRenderOnSelectedHook() {
          history.replaceState(
            history.state,
            '',
            updateUrlParams(location.href, { tab: MY_PAGE_TABS_MAP.commission }),
          );
        },
        catchOnErrorHook(myPageTabHookError?: MyPageTabsHookError) {
          if (RenderOnRefreshHookError.is(myPageTabHookError)) {
            ConfigSentryF.capture(myPageTabHookError);
          }
        },
      },
      support: {
        selected: MY_PAGE_TABS_MAP.support === this.data.selected_tab,
        value: ET('mps2::membership::support::title'),
        view: new SupportTab(this.data),
        postRenderOnSelectedHook() {
          history.replaceState(
            history.state,
            '',
            updateUrlParams(location.href, { tab: MY_PAGE_TABS_MAP.support }),
          );
        },
        catchOnErrorHook(myPageTabHookError?: MyPageTabsHookError) {
          if (RenderOnRefreshHookError.is(myPageTabHookError)) {
            ConfigSentryF.capture(myPageTabHookError);
          }
        },
      },
      paymethod: {
        selected: MY_PAGE_TABS_MAP.paymethod === this.data.selected_tab,
        value: ET('mps2::membership::paymethod'),
        view: new MembershipPayMethod(this.data),
        postRenderOnSelectedHook() {
          history.replaceState(
            history.state,
            '',
            updateUrlParams(location.href, { tab: MY_PAGE_TABS_MAP.paymethod }),
          );
        },
        catchOnErrorHook(myPageTabHookError?: MyPageTabsHookError) {
          if (RenderOnRefreshHookError.is(myPageTabHookError)) {
            ConfigSentryF.capture(myPageTabHookError);
          }
        },
      },
    };
  }

  override template() {
    const { selected_tab, url, layout_options } = this.data;
    const { is_mobile } = layout_options;

    return html`
      <div class="${klass.body}">
        ${new MyPageBody({
          my_page_tabs_option_map: this.my_page_tabs_option_map,
          selected_tab,
          url,
          is_mobile,
        })}
      </div>
    `;
  }
}

export class MyMembershipPage extends Page<MyMembershipPageData> {
  override template() {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    return html`
      <div>
        ${new LayoutView(
          {
            body: new MyMembershipBodyView(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: true,
            full_width: true,
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
